import { render, staticRenderFns } from "./CollectionInsightsPanel.vue?vue&type=template&id=72cfd7be&scoped=true&"
import script from "./CollectionInsightsPanel.vue?vue&type=script&lang=js&"
export * from "./CollectionInsightsPanel.vue?vue&type=script&lang=js&"
import style0 from "./CollectionInsightsPanel.vue?vue&type=style&index=0&id=72cfd7be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cfd7be",
  null
  
)

export default component.exports